import { AxiosResponse } from 'axios';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import { getAllUsersApi } from "../../services/users.service";
import actions from "./actions";

export function* GET_ALL_USERS() {
    try {
        const response: AxiosResponse<any> = yield call(getAllUsersApi);
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) {

    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_USERS)
    ])
}
